module.exports = __webpack_public_path__ + "static/enable-figma-library-a-55e6ff53ee32d3d217b04a9603fc4028.png";